import {combineReducers} from "@reduxjs/toolkit"
import state from "./state-slice"
import entries from "./entries-slice"
import editor from "./editor-slice"

const accounting = combineReducers({
    state, entries, editor
})
export default accounting
